import { type FC } from 'react'
import { Status } from 'shared/ui'
import { rcsStatusConfig } from 'entities/Compliance/ui/RcsStatus/config'
import { type IRcsStatus } from './type'

type IRcsStatusProps = {
  status: IRcsStatus
  title?: string
}

export const RcsStatus: FC<IRcsStatusProps> = ({ status, title }) => {
  if (!status) return null

  return <Status {...rcsStatusConfig[status]} {...(title ? { title } : {})} />
}
